// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"df77ddaf","336":"be02dbae","390":"d5dd0560","425":"d5dd0560","442":"3220b634","554":"df77ddaf","831":"6be49a49","836":"d7abaaaf","921":"df77ddaf","925":"3220b634"}[chunkId] + ".chunk.css";
};